export default "__VITE_ASSET__oXloA8vO__"